import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  "data-error": "unknown-view-mode"
}

import { type PropType, computed } from "vue";
import { getCollectionUrl as getColUrl } from "./collection-url";
import defaultView from "./view-modes/default/list.vue";
import multipleCheckboxesView from "./view-modes/multiple-checkboxes/list.vue";
import {
    type MappedProductCollectionModel,
    type ProductCollectionModel,
} from "./models";
import { makeGroupedValue } from "./value";
import { FilterViewMode } from "./view-modes/types";
//import { flattenAllCollections } from "./collection-methods";

export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  props: {
    filler: {
        type: Boolean,
        default: false,
    },
    viewMode: {
        type: Number as PropType<FilterViewMode>,
        required: true,
    },
    siteGuid: Number,
    productListGuid: Number,
    value: Array as PropType<number[][]>,
    root: {
        type: Array as PropType<MappedProductCollectionModel[]>,
        required: true,
    },
    scopedRoot: Object as PropType<MappedProductCollectionModel>,
    baseUrl: {
        type: String,
    },
    getVisible: {
        type: Function,
        required: true,
    },
    matchedLogicalName: String,
    matchedLogicalNameEntityGuid: Number,
    matchedLogicalNameModuleGuid: Number,
    matchedLogicalNameSubModuleGuid: Number,
    forceBackArrow: Boolean,
},
  emits: ["input", "update-product-count"],
  setup(__props, { emit: __emit }) {

const props = __props;

const allProps = computed(() => {
    return {
        viewMode: props.viewMode,
        siteGuid: props.siteGuid,
        //collectionId: props.collectionId,
        productListGuid: props.productListGuid,
        value: props.value,
        root: props.root,
        scopedRoot: props.scopedRoot,
        baseUrl: props.baseUrl,
        getVisible: props.getVisible,
        //makeGroupedValue: props.makeGroupedValue,
        getCollectionUrl: getCollectionUrl,
        //findCollectionById: findCollectionById,
        //getFlattenedCollections: getFlattenedCollections,
        forceBackArrow: props.forceBackArrow,
        matchedLogicalName: props.matchedLogicalName,
        matchedLogicalNameEntityGuid: props.matchedLogicalNameEntityGuid,
        matchedLogicalNameModuleGuid: props.matchedLogicalNameModuleGuid,
        matchedLogicalNameSubModuleGuid: props.matchedLogicalNameSubModuleGuid,
    };
});
function getCollectionUrl(item: MappedProductCollectionModel) {
    return getColUrl(
        item,
        props.viewMode,
        props.baseUrl,
        props.value,
        props.root,
        props.matchedLogicalName,
        props.matchedLogicalNameEntityGuid,
        props.matchedLogicalNameModuleGuid,
        props.matchedLogicalNameSubModuleGuid
    );
}
// function findCollectionById(
//     collectionId: number,
//     mappedRoot: ProductCollectionModel[] | MappedProductCollectionModel[] | undefined
// ) {
//     for (const collection of flattenAllCollections(mappedRoot)) {
//         if (collection.Id == collectionId) return collection;
//     }
//     return undefined;
// }
// function* getFlattenedCollections(
//     collections: ProductCollectionModel[]
// ): Generator<ProductCollectionModel> {
//     if (collections != null) {
//         for (const collection of collections) {
//             yield collection;
//             for (const subCollection of getFlattenedCollections(
//                 collection.SubCollections
//             )) {
//                 yield subCollection;
//             }
//         }
//     }
// }

function navigateToCollection(
    item:
        | {
              collection: ProductCollectionModel;
              scopedRoot: ProductCollectionModel | undefined;
          }
        | ProductCollectionModel
        | undefined
        | null
) {
    if (item == null) {
        emitValue(null);
    } else {
        const col = "collection" in item ? item.collection : item;
        const val = makeGroupedValue(
            col.Id,
            undefined,
            props.viewMode,
            props.root
        );

        emitValue(
            val.value,
            "scopedRoot" in item ? item.scopedRoot : undefined
        );
    }
}

const emit = __emit;

function emitValue(
    value: number[][] | null | undefined,
    scopedRoot?: ProductCollectionModel | undefined
) {
    emit("input", { value, scopedRoot });
}
// function fullPath(dir) {
//     const parts = Array.from(navDown(dir)).map((x) => x.name);
//     return parts.join(" / ");
// }
// function* navDown(dir) {
//     const reversed = Array.from(navUp(dir)).reverse();
//     for (const item of reversed) yield item;
// }
// function* navUp(dir) {
//     yield dir;
//     if (dir.parent != null) {
//         for (const parent of navUp(dir.parent)) yield parent;
//     }
// }

return (_ctx: any,_cache: any) => {
  return (__props.viewMode === _unref(FilterViewMode).Default)
    ? (_openBlock(), _createBlock(defaultView, _mergeProps({ key: 0 }, allProps.value, {
        onNavigateToCollection: _cache[0] || (_cache[0] = ($event: any) => (navigateToCollection($event)))
      }), null, 16 /* FULL_PROPS */))
    : (__props.viewMode === _unref(FilterViewMode).MultipleCheckboxes)
      ? (_openBlock(), _createBlock(multipleCheckboxesView, _mergeProps({ key: 1 }, allProps.value, {
          onUpdateProductCount: _cache[1] || (_cache[1] = ($event: any) => (emit('update-product-count'))),
          onNavigateToCollection: _cache[2] || (_cache[2] = ($event: any) => (navigateToCollection($event))),
          onEmitValue: _cache[3] || (_cache[3] = ($event: any) => (emitValue($event)))
        }), null, 16 /* FULL_PROPS */))
      : (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})